import { ApiServiceLevelEnum, ProductFeatureKeyEnum } from '../types';
import { FeatureNameEnum, getFeatureForTierAsBoolean } from './feature-tiers-constants';
const featureAccessAtoFeatureNameMapping = {
    [ProductFeatureKeyEnum.TRANSLATIONS]: FeatureNameEnum.AUTO_TRANSLATIONS,
    [ProductFeatureKeyEnum.MANAGE_ENVIRONMENTS]: FeatureNameEnum.CUSTOM_ENVIRONMENTS_BOOLEAN,
    [ProductFeatureKeyEnum.WEBHOOKS]: FeatureNameEnum.WEBHOOKS,
    [ProductFeatureKeyEnum.AGENT_EMAIL_INTEGRATION]: FeatureNameEnum.AGENT_EMAIL_INTEGRATION,
    [ProductFeatureKeyEnum.CUSTOM_DOMAINS]: FeatureNameEnum.DOMAINS_BOOLEAN,
};
function createProductFeatureMap() {
    const productFeatures = {
        [ProductFeatureKeyEnum.TRANSLATIONS]: [],
        [ProductFeatureKeyEnum.MANAGE_ENVIRONMENTS]: [],
        [ProductFeatureKeyEnum.WEBHOOKS]: [],
        [ProductFeatureKeyEnum.AGENT_EMAIL_INTEGRATION]: [],
        [ProductFeatureKeyEnum.CUSTOM_DOMAINS]: [],
    };
    for (const apiServiceLevel of Object.values(ApiServiceLevelEnum)) {
        for (const [productFeatureKey, featureName] of Object.entries(featureAccessAtoFeatureNameMapping)) {
            const typedProductKey = productFeatureKey;
            if (Object.values(ProductFeatureKeyEnum).includes(typedProductKey)) {
                const isFeatureEnabled = getFeatureForTierAsBoolean(featureName, apiServiceLevel);
                if (isFeatureEnabled) {
                    productFeatures[typedProductKey].push(apiServiceLevel);
                }
            }
        }
    }
    return Object.freeze(productFeatures);
}
export const productFeatureEnabledForServiceLevel = createProductFeatureMap();
//# sourceMappingURL=productFeatureEnabledForServiceLevel.js.map